import iviewLangs from './config/iview.lang.config'
import zhLang from './config/zh-CN'
import enLang from './config/en-US'
import jaLang from './config/ja-JP'
import koLang from './config/ko-KR'
import twLang from './config/zh-TW'

const messages = {
  zh_CN: Object.assign(zhLang, iviewLangs['zh']),
  en_US: Object.assign(enLang, iviewLangs['en']),
  ja_JP: Object.assign(jaLang, iviewLangs['ja']),
  ko_KR: Object.assign(koLang, iviewLangs['ko']),
  tw_CN: Object.assign(twLang, iviewLangs['tw'])
}

const files = require.context('', true, /\.js$/);
files.keys().forEach(file => {
    const names = file.split('/');
    if(names.length == 4){
      let i18n = files(file).default;
      for(var p in messages){
        if(i18n[p]){
            messages[p] = Object.assign(messages[p],i18n[p])
        }
      }
    }
});

const localeI18n = {
  locale: 'zh_CN', // set locale
  fallbackLocale: 'zh_CN',
  messages // set locale messages
}

export default localeI18n
